module.exports = __webpack_public_path__ + "images/icon-mobile-app-inviter.27b3927f.svg";